"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (htmlEncodedString) {
    var txt = document.createElement('textarea');
    txt.innerHTML = htmlEncodedString;
    return txt.value;
});
